export default __webpack_public_path__ + "cd3b257cf57eb0011e55daaf3130dd50.png";